import { StreemAPI, StreemApiDeviceSupportedVideoPlatforms } from '@streem/api';
import { invariant } from '@streem/toolbox';
import { logger } from '../../util/logger';
function credentialsAreChime(credentials) {
    return credentials.Attendee.JoinToken !== undefined;
}
export class RoomTokenController {
    constructor() {
        this.log = logger.extend('sdk:room_token_controller');
    }
    get roomVideoCredentialsAndPlatform() {
        const credentials = this.getCredentials();
        invariant(credentials, 'room credentials must be defined');
        if (credentials === undefined) {
            return {
                videoPlatform: StreemApiDeviceSupportedVideoPlatforms.INVALID,
                roomVideoCredentials: undefined,
            };
        }
        else if (credentialsAreChime(credentials)) {
            return {
                videoPlatform: StreemApiDeviceSupportedVideoPlatforms.CHIME,
                roomVideoCredentials: credentials,
            };
        }
        throw new Error('Invalid room credentials');
    }
    async fetchRoomVideoCredentials(roomId, localUserId, mediaRegion) {
        this.roomVideoCredentials = undefined;
        try {
            const roomVideoCredentialsResponse = await StreemAPI.rooms.createRoomVideoCredentials(roomId.toString(), localUserId.toString(), {
                mediaRegion,
            });
            if (roomVideoCredentialsResponse.chimeRoomVideoCredentials !== undefined) {
                this.roomVideoCredentials = this.convertChimeResponseToChimeRoomVideoCredentials(roomVideoCredentialsResponse.chimeRoomVideoCredentials);
            }
            else {
                this.log.error('Invalid room video credentials response:', roomVideoCredentialsResponse);
            }
        }
        catch (error) {
            this.log.error('Unable to create room video credentials: ', error);
        }
    }
    disconnect() {
        this.roomVideoCredentials = undefined;
    }
    hasToken() {
        return this.getCredentials() !== undefined;
    }
    getCredentials() {
        return this.roomVideoCredentials;
    }
    // The AWS Chime SDKs use Pascal case for their properties, but Streem APIs return camel-case, so
    //       we need to convert
    convertChimeResponseToChimeRoomVideoCredentials(response) {
        const responseMeeting = response.meeting;
        invariant(responseMeeting, 'Chime response must have a meeting');
        const chimeAttendee = response.attendee;
        invariant(chimeAttendee, 'Chime response must have an attendee');
        const meeting = {
            ExternalMeetingId: responseMeeting.externalMeetingId,
            MediaPlacement: {
                AudioFallbackUrl: responseMeeting.mediaPlacement.audioFallbackUrl,
                AudioHostUrl: responseMeeting.mediaPlacement.audioHostUrl,
                EventIngestionUrl: responseMeeting.mediaPlacement.eventIngestionUrl,
                ScreenDataUrl: responseMeeting.mediaPlacement.screenDataUrl,
                ScreenSharingUrl: responseMeeting.mediaPlacement.screenSharingUrl,
                ScreenViewingUrl: responseMeeting.mediaPlacement.screenViewingUrl,
                SignalingUrl: responseMeeting.mediaPlacement.signalingUrl,
                TurnControlUrl: responseMeeting.mediaPlacement.turnControlUrl,
            },
            MediaRegion: responseMeeting.mediaRegion,
            MeetingArn: responseMeeting.meetingArn,
            MeetingId: responseMeeting.meetingId,
            TenantIds: [], // TODO: figure out if these is needed
        };
        const attendee = {
            AttendeeId: chimeAttendee.attendeeId,
            Capabilities: {
                Audio: chimeAttendee.attendeeCapabilities.audio,
                Content: chimeAttendee.attendeeCapabilities.content,
                Video: chimeAttendee.attendeeCapabilities.video,
            },
            ExternalUserId: chimeAttendee.externalUserId,
            JoinToken: chimeAttendee.joinToken,
        };
        return {
            Meeting: meeting,
            Attendee: attendee,
        };
    }
}
//# sourceMappingURL=room_token_controller.js.map